<template>
  <div class="pagination-controls is-clearfix">
      <div class="buttons has-addons is-right">
        <span class="button" @click="previous">Previous</span>
        <span  class="button current-page">{{currentPage}}</span>
        <span class="button" @click="next">Next</span>
      </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('walletTx', ['currentPage'])
  },
  methods: {
    previous () {
      this.$store.dispatch('walletTx/prev')
    },
    next () {
      this.$store.dispatch('walletTx/next')
    }
  }
}
</script>
<style lang="scss" scoped>
  .buttons {
    border-radius: 4px;
    .button {
      width: auto;
      border-color: #ddd;
      letter-spacing: 0px;
      font-weight: normal;
      text-transform: capitalize;
      border-left-width: 0px;
      border-right-width: 0px;

      &:first-child {
        border-left-width: 1px;
      }
      &:last-child {
        border-right-width: 1px;
      }

    }

    .current-page {
      border-bottom:5px solid #44c7f0;
      font-weight: bolder;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wallet/paging-controls.vue